import { render, staticRenderFns } from "./quotationTable.vue?vue&type=template&id=db98ff34&scoped=true"
import script from "./quotationTable.vue?vue&type=script&lang=js"
export * from "./quotationTable.vue?vue&type=script&lang=js"
import style0 from "./quotationTable.vue?vue&type=style&index=0&id=db98ff34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db98ff34",
  null
  
)

export default component.exports